import React, { useState, useRef, useMemo } from "react";
import { BiSend } from "react-icons/bi";
import { Row, Col } from "react-bootstrap";
import JoditEditor from "jodit-react";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
const baseURL = process.env.REACT_APP_API;

export default function Add({
  increment,
  counter,
  moamad,
  mailTypeOptions,
  setNewEmail,
  setEmailToDisplay,
}) {
  const hiddenButton = useRef(null);
  const [newEmailToAdd, setNewEmailToAdd] = useState({
    mail_type: "",
    sender: "",
    subject: "",
    content: "",
    date: "",
    time: "",
    mekhraz: 11, //moamad.mekhraz,
    moamad: 1, //moamad.id,
  });
  const [meeting, setMeeting] = useState({});
  const axiosPrivate = useAxiosPrivate("application/json");

  const editor1 = useRef(null);
  const config = useMemo(
    () => ({
      readonly: false,
      height: 400,
      width: 600,
      askBeforePasteFromWord: false,
      askBeforePasteHTML: false,
      //colorPickerDefaultTab: "background",
      //buttons: ["brush"],
      toolbarAdaptive: false,
      disablePlugins: ["File", "Image", "Media"],
    }),
    []
  );

  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;

    setNewEmailToAdd((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let isMounted = true;
    const controller = new AbortController();
    const addData = async () => {
      try {
        const response = await axiosPrivate.post(
          baseURL + "jobs/moamademail/",
          newEmailToAdd,
          {
            signal: controller.signal,
          }
        );
        console.log("Dont delete1");

        //isMounted && setRefreshMoamads((prev) => !prev);

        setEmailToDisplay(response.data);

        setNewEmail(false);
        alert("המייל נשלח בהצלחה");
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };
    addData();
    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  };

  // render
  return (
    <div>
      <div className="border-danger container" bg="light">
        {/*  <div className="card text-dark bg-light container p-3  border">
        <Card className="border-danger container px-5" bg="light">*/}
        <div className="card-header">
          <h3 style={{ textAlign: "center" }}>
            {/*  שליחת דואר אלקטרוני ל: {moamad.f_name} {moamad.father_name}{" "}
            {moamad.l_name}*/}
          </h3>
        </div>
        <div className="card-body">
          <Row>
            <Col>
              <form
                onSubmit={handleSubmit}
                className="mbsc-form-group "
                ref={hiddenButton}
              >
                <Row>
                  <Col>
                    <div className="form-group ">
                      <label htmlFor="mail_type">בחר סוג ההודעה: </label>
                      <select
                        name="mail_type"
                        onChange={handleChange}
                        value={newEmailToAdd.mail_type}
                        required
                      >
                        <option key="0" value="" selected>
                          בחר סוג
                        </option>
                        {mailTypeOptions?.map((a) => (
                          <option key={a[0]} value={a[1]}>
                            {a[1]}
                          </option>
                        ))}
                      </select>
                    </div>
                  </Col>

                  <Col>
                    <div className="form-group">
                      <label htmlFor="subject">תוספת לכותרת של המייל</label>
                      <input
                        type="text"
                        name="subject"
                        className="form-control"
                        id="subject"
                        value={newEmailToAdd.subject}
                        placeholder="התוכן יתווסף לסוג המייל "
                        onChange={handleChange}
                      />
                    </div>
                  </Col>
                </Row>
                <Row style={{ float: "right" }}>
                  <Col>
                    <div className="form-group ">
                      <label htmlFor="date">תאריך</label>
                      <input
                        type="date"
                        name="date"
                        className="form-control"
                        id="date"
                        value={newEmailToAdd.date}
                        placeholder="תאריך ההזמנה"
                        onChange={handleChange}
                      />
                    </div>
                  </Col>
                  <Col>
                    <div className="form-group">
                      <label htmlFor="time">שעה</label>
                      <input
                        type="time"
                        name="time"
                        className="form-control"
                        id="time"
                        value={newEmailToAdd.time}
                        placeholder="שעה"
                        onChange={handleChange}
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <center>
                      <label htmlFor="content"> הערות נוספות</label>
                    </center>
                    <JoditEditor
                      editorRef={editor1}
                      name="content"
                      tabIndex={1}
                      value={newEmailToAdd.content}
                      config={config}
                      onBlur={(newContent) => {
                        setNewEmailToAdd((prevState) => ({
                          ...prevState,
                          content: newContent,
                        }));
                        hiddenButton.current.focus();
                      }}
                    />
                  </Col>
                </Row>

                <button type="submit" className="btn btn-primary">
                  שלח <BiSend rotate={90} />
                </button>
              </form>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
}
